/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerBlockValidationTypeFields.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Validation Fields
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Tuesday, September 25, 2018 - 08:09:59 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      09/25/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    VALIDATIONFIELD_LIST_CONTAINER_LOADED,
    VALIDATIONFIELD_LIST_CONTAINER_UNLOADED,
    VALIDATIONFIELD_LIST_TABLE_LOADED,
    VALIDATIONFIELD_LIST_TABLE_UNLOADED,

    VALIDATIONFIELD_SELECT_ROW,
    VALIDATIONFIELD_ADD,
    VALIDATIONFIELD_EDIT,
    VALIDATIONFIELD_DELETE,
    VALIDATIONFIELD_OPEN_WARNING,
    VALIDATIONFIELD_CLOSE_WARNING,

    VALIDATIONFIELD_EDIT_CONTAINER_LOADED,
    VALIDATIONFIELD_EDIT_CONTAINER_UNLOADED,
    VALIDATIONFIELD_EDIT_FORM_LOADED,
    VALIDATIONFIELD_EDIT_FORM_UNLOADED,
    VALIDATIONFIELD_SET_DATATYPE_SELECT,
    VALIDATIONFIELD_EDIT_DATA_LOAD,
    VALIDATIONFIELD_EDIT_CONTAINER_SUBMIT,
    VALIDATIONFIELD_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeBlockValidationTypeFields';

const defaultState = {
    refreshList: false,
    danger: false,
    validationfieldid: 0,
    validationtypeid: 0,
    name: '',
    description: '',
    datatypeid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case VALIDATIONFIELD_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                validationfields: action.payload[0] ? action.payload[0].records : null,
                validationtype: action.payload[1] ? action.payload[1] : null
            }
        case VALIDATIONFIELD_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case VALIDATIONFIELD_SELECT_ROW:
            return {
                ...state,
                validationfieldid: action.id
            }
        case VALIDATIONFIELD_ADD:
            return {
                ...state
            }
        case VALIDATIONFIELD_EDIT:
            return {
                ...state,
                validationfieldid: action.id
            }
        case VALIDATIONFIELD_DELETE:
            return {
                ...state,
                validationfieldid: null
            }
        case VALIDATIONFIELD_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case VALIDATIONFIELD_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case VALIDATIONFIELD_SET_DATATYPE_SELECT:
            return {
                ...state,
                dataTypeOptions: action.payload ? action.payload : null
            }
        case VALIDATIONFIELD_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                validationfieldid: action.payload[0] ? action.payload[0].validationfieldid : 0,
                validationtypeid: action.payload[0] ? action.payload[0].validationtypeid : action.payload[1].validationtypeid,
                validationtype: action.payload[0] ? action.payload[0].validationtype : action.payload[1].name,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                datatypeid: action.payload[0] ? action.payload[0].datatypeid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case VALIDATIONFIELD_EDIT_DATA_LOAD:
            return {
                ...state,
                validationfieldid: action.payload ? action.payload.validationfieldid : 0,
                validationtypeid: action.payload ? action.payload.validationtypeid : 0,
                validationtype: action.payload ? action.payload.validationtype : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                datatypeid: action.payload ? action.payload.datatypeid : 0,
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case VALIDATIONFIELD_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case VALIDATIONFIELD_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case VALIDATIONFIELD_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case VALIDATIONFIELD_LIST_CONTAINER_UNLOADED:
        case VALIDATIONFIELD_LIST_TABLE_UNLOADED:
        case VALIDATIONFIELD_EDIT_CONTAINER_UNLOADED:
        case VALIDATIONFIELD_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerBlockValidationTypeFields.js